module.exports = __webpack_public_path__ + "static/media/loadingImg.e51cf8fc.png";